import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'icon-info',
	styleUrls: ['./icon-info.components.scss'],
	template:
		`
		<i class="fa-light fa-circle-info"></i>
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true
})
export class IconInfoComponent { }
